/* eslint-disable */
export default function init(Blockly, profile) {
    Blockly.Arduino.variables = {};
    Blockly.Arduino.variables_set = function() {
      var a = Blockly.Arduino.valueToCode(this, "VALUE", Blockly.Arduino.ORDER_ASSIGNMENT) || "0";
      return (
        "" +
        Blockly.Arduino.nameDB_.getName(
          this.getFieldValue("VAR"),
          Blockly.VARIABLE_CATEGORY_NAME) +
        " = " +
        a +
        ";\n"
      );
    };
    Blockly.Arduino.variables_get = function() {
      return [
        "" +
        Blockly.Arduino.nameDB_.getName(
          this.getFieldValue("VAR"),
          Blockly.VARIABLE_CATEGORY_NAME),
        Blockly.Arduino.ORDER_ATOMIC
      ];
    };
    Blockly.Arduino.variables_set_number = function() {
      var a = Blockly.Arduino.valueToCode(this, "VALUE", Blockly.Arduino.ORDER_ASSIGNMENT) || "0";
      return (
        "" +
        Blockly.Arduino.nameDB_.getName(
          this.getFieldValue("VAR"),
          Blockly.VARIABLE_CATEGORY_NAME) +
        " = " +
        a +
        ";\n"
      );
    };
    Blockly.Arduino.variables_get_number = function() {
      return [
        "" +
        Blockly.Arduino.nameDB_.getName(
          this.getFieldValue("VAR"),
          Blockly.VARIABLE_CATEGORY_NAME),
        Blockly.Arduino.ORDER_ATOMIC
      ];
    };
    Blockly.Arduino.variables_set_text = function() {
      var a = Blockly.Arduino.valueToCode(this, "VALUE", Blockly.Arduino.ORDER_ASSIGNMENT) || '""';
      return (
        "" +
          Blockly.Arduino.nameDB_.getName(
          this.getFieldValue("VAR"),
          Blockly.VARIABLE_CATEGORY_NAME
        ) +
        " = " +
        a +
        ";\n"
      );
    };
    Blockly.Arduino.variables_get_text = function() {
      return [
        "" +
            Blockly.Arduino.nameDB_.getName(
            this.getFieldValue("VAR"),
            Blockly.VARIABLE_CATEGORY_NAME
          ),
        Blockly.Arduino.ORDER_ATOMIC
      ];
    };
    Blockly.Arduino.variables_set_bool = function() {
      var a = Blockly.Arduino.valueToCode(this, "VALUE", Blockly.Arduino.ORDER_ASSIGNMENT) || "false";
      return (
        "" +
          Blockly.Arduino.nameDB_.getName(
          this.getFieldValue("VAR"),
          Blockly.VARIABLE_CATEGORY_NAME
        ) +
        " = " +
        a +
        ";\n"
      );
    };
    Blockly.Arduino.variables_get_bool = function() {
      return [
        "" +
            Blockly.Arduino.nameDB_.getName(
            this.getFieldValue("VAR"),
            Blockly.VARIABLE_CATEGORY_NAME
          ),
        Blockly.Arduino.ORDER_ATOMIC
      ];
    };
}
